import React, { useState, forwardRef, useCallback, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Grid from '@mui/joy/Grid';
import Button from '@mui/joy/Button';
import Input from '@mui/joy/Input';
import Autocomplete from '@mui/joy/Autocomplete';
import Box from '@mui/joy/Box';
import { useNavigate } from 'react-router-dom'


/////////////////// Modal
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import Stack from '@mui/joy/Stack';
import Textarea from '@mui/joy/Textarea';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


//////////////////// API
import { createNewBrand, getBrands, getBrandsBySearch, getBrandsInRegisterModel } from '../../Api/Brands';


import TableCarBrand from '../../Components/CarPages/CarBrand/Table';
import TableCarModal from '../../Components/CarPages/CarModal/table';
import UploadFileModels from '../../Components/StaticPages/UploadFileModels';


import AddIcon from '../../assets/icons/Add-icon.svg'
import SearchIcon from '@mui/icons-material/Search';

const schema = yup.object({
    // image: yup.mixed().required("يرجى رفع صورة القسم"),
    title_ar: yup.string().required("هذا الحقل مطلوب"),
    title_en: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;


export default function CarBrand() {
    const [currentTab, setCurrentTab] = useState(0);
    const [currentTabActive, setCurrentTabActive] = useState(0)
    const [listBrands, setListBrands] = useState([]);
    const [open, setOpen] = useState(false);
    const [urlImageName, setUrlImageName] = useState("قم برفع شعار الماركة")
    const [imageDataTwo, setImageDataTwo] = useState(null)
    const [brandId, setBrandId] = useState(null)

    const [openModalConfirm, setOpenModalConfirm] = useState(false)
    const [loadingData, setLoadingData] = React.useState(false)
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const [searchData, setSearchData] = useState(null);
    const [roleId, setRoleId] = useState([])
    const [adminType, setAdminType] = useState(null)

    const navigate = useNavigate();

    const getCurrentTabs = (event, newValue) => {
        // console.log(newValue)
        // console.log(event)
        setCurrentTab(newValue)
        setCurrentTabActive(newValue)
    }

    const navigateToPage = () => {
        if (currentTab == 1) {
            navigate('/cars/add-new-model')
        }
    };

    const navigateToPageAccess = () => {
        navigate('/cars/add-new-model')

    };


    const form = useForm({
        defaultValues: {
            // image: '',
            title_ar: "",
            title_en: "",
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const listAllBrands = useCallback(async () => {
        setLoadingData(true)
        const res = await getBrandsInRegisterModel();
        if (res) {
            setLoadingData(false)
            setListBrands(res)
        }
    }, [])

    const imgNews = (event) => {
        let image = event.target;
        if (image.files && image.files[0]) {
            setImageDataTwo(image.files[0]);
            console.log(image.files[0])
            setUrlImageName(image.files[0].name)
            var reader = new FileReader();
            // reader.onload = (e) => {
            //     setUrlImage(e.target.result);
            // }
            reader.readAsDataURL(image.files[0]);
        }
    };


    const sendNewBrand = async (data) => {
        setLoading(true)
        if (data.image) {
            data.image = data.image[0]
        }

        try {
            const res = await createNewBrand(data)
            if (res) {
                setLoading(false)
                setOpen(false)
                listAllBrands()
                setOpenAlert(true)
                setMessageAlert('تم اضافة قسم بنجاح')
                setValue('image', '')
                setValue('title_ar', '')
                setValue('title_en', '')
                setImageDataTwo(null)
                setUrlImageName("قم برفع صورة الماركة")
            }

        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpen(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    };

    const getCurentTabe = useCallback(() => {
        let curentTab = localStorage.getItem('activeTabCarsInSoomha')
        if (curentTab == 'models') {
            setCurrentTabActive(1)
            setCurrentTab(1)
            setTimeout(() => {
                localStorage.setItem('activeTabCarsInSoomha', null)
            }, 500)
        } else {
            setCurrentTab(0)
            setCurrentTabActive(0)
        }
    }, [])

    const getSearchData = async (e) => {
        setLoadingData(true)
        // console.log(e.target.value)
        setSearchData(e.target.value)
        if (e.target.value) {
            const res = await getBrandsBySearch(e.target.value)
            if (!res) {
                return
            }
            setLoadingData(false)
            setListBrands(res)
        } else {
            listAllBrands()
        }

    }


    const getRoleAamin = useCallback(async () => {
        let role = await JSON.parse(localStorage.getItem("adminRoleSoomha"));
        let typeAdmin = await JSON.parse(localStorage.getItem("typeAdminSoomha"));
        let roles = role.map((roleIds) => {
            return roleIds.role_id
        })
        let numberArray = roles.map(Number);
        setRoleId(numberArray)
        setAdminType(typeAdmin)
    }, [])

    useEffect(() => {
        getRoleAamin()
    }, [getRoleAamin])

    useEffect(() => {
        getCurentTabe()
    }, [])

    useEffect(() => {
        listAllBrands();
    }, [listAllBrands])

    return (
        <>
            {/* Modal Create New */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                onClose={() => setOpen(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        Width: 500,
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        position: 'relative',
                    }}
                >
                    <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold', direction: 'rtl' }}>إضافة ماركة جديدة</DialogTitle>
                    {/* <ModalClose variant="plain" sx={{ m: 1, position: 'absolute', left: '0' }} /> */}
                    <Box sx={{ width: '500px', paddingTop: '30px', direction: 'rtl' }}>
                        <form
                            onSubmit={handleSubmit(sendNewBrand)}
                        >
                            <Stack spacing={2}>
                                <FormControl>
                                    <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>الماركة باللغة العربية</FormLabel>
                                    <Input
                                        sx={{
                                            height: '60px',
                                            borderRadius: '30px'
                                        }}
                                        autoFocus
                                        placeholder='ادخل الماركة باللغة العربية'
                                        {...register('title_ar')}
                                    />
                                    {errors.title_ar &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.title_ar?.message}</Typography>
                                    }
                                </FormControl>
                                <FormControl sx={{ direction: 'ltr' }}>
                                    <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>Brand Name</FormLabel>
                                    <Input
                                        sx={{
                                            height: '60px',
                                            borderRadius: '30px'
                                        }}
                                        autoFocus
                                        placeholder='Brand Name .....'
                                        {...register('title_en')}
                                    />
                                    {errors.title_en &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.title_en?.message}</Typography>
                                    }
                                </FormControl>

                                {/* <FormControl>
                                    <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>الشعار</FormLabel>
                                    <Button
                                        component="label"
                                        role={undefined}
                                        tabIndex={-1}
                                        variant="outlined"
                                        color="neutral"
                                        sx={{ border: '1px solid #E6E6E6', padding: '0', position: 'relative', height: '60px', paddingLeft: '40%', borderRadius: '30px' }}
                                        endDecorator={
                                            <Box sx={{ backgroundColor: '#3E64F4', color: '#FFF', position: 'absolute', left: '0', top: '0', width: '30%', height: '60px', textAlign: 'center', lineHeight: '60px', borderRadius: '30px' }}>
                                                Upload
                                            </Box>
                                        }
                                    >
                                        {urlImageName}
                                        <VisuallyHiddenInput type="file" {...register('image')} onChange={(e) => imgNews(e)} />
                                    </Button>
                                    {errors.image &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.image?.message}</Typography>
                                    }
                                </FormControl> */}

                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '40px' }}>
                                    <Button type="submit" loading={loading} sx={{ borderRadius: '15px', backgroundColor: '#3E64F4', height: '60px', width: '170px', marginLeft: '20px' }}>اضافة الماركة</Button>
                                    <Button type="button" onClick={() => setOpen(false)} sx={{ borderRadius: '15px', backgroundColor: '#757778', height: '60px', width: '170px' }}>الغاء</Button>
                                </Box>
                            </Stack>
                        </form>
                    </Box>
                </Sheet>
            </Modal>


            <Tabs
                variant='plain'
                aria-label="Pricing plan"
                defaultValue={0}
                onChange={getCurrentTabs}
                value={currentTabActive}
                sx={{
                    width: '100%',
                    borderRadius: 'sm',
                    // boxShadow: 'sm',
                    overflow: 'auto',
                    backgroundColor: '#FBFBFB',
                }}
            >
                <TabList
                    disableUnderline
                    tabFlex={1}
                    size='lg'
                    sx={{
                        width: '40% !important',
                        [`& .${tabClasses.root}`]: {
                            fontSize: 'sm',
                            fontWeight: 'lg',
                            bgcolor: '#FBFBFB',

                            [`&[aria-selected="true"]`]: {
                                color: 'primary.500',
                                bgcolor: '#FBFBFB',
                            },
                            [`&.${tabClasses.focusVisible}`]: {
                                outlineOffset: '-4px',
                            },
                        },
                    }}
                >


                    {(adminType == 0) ? (
                        <>
                            <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                                الماركات
                            </Tab>
                            <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                                الموديلات
                            </Tab>
                            <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                                رفع ملف الموديلات
                            </Tab>
                        </>
                    ) : (
                        <>
                            <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                                الموديلات
                            </Tab>
                            <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                                رفع ملف الموديلات
                            </Tab>
                        </>
                    )}

                </TabList>
                <Grid container spacing={2} sx={{ flexGrow: 1, padding: '30px 2%', backgroundColor: '#FFF', justifyContent: currentTab == 1 ? 'flex-end' : 'flex-start', marginTop: '0' }}>
                    {currentTab == '0' && adminType == 0 ? (
                        <Grid container xs={8}>
                            <Grid xs={8}>
                                <Input
                                    placeholder="ابحث باسم الماركة"
                                    onChange={(e) => getSearchData(e)}
                                    sx={{
                                        '--Input-focusedInset': 'var(--any, )',
                                        '--Input-focusedThickness': '0.25rem',
                                        '--Input-focusedHighlight': 'rgba(13,110,253,.25)',
                                        '&::before': {
                                            transition: 'box-shadow .15s ease-in-out',
                                        },
                                        '&:focus-within': {
                                            borderColor: '#B9B9B9',
                                        },
                                        width: '100%',
                                        height: '45px',
                                        borderRadius: '32px',
                                        color: '#B9B9B9'
                                    }}
                                    startDecorator={<SearchIcon sx={{ color: '#B9B9B9' }} />}

                                />
                            </Grid>
                        </Grid>
                    ) : false}
                    {adminType == 0 && currentTab != '2'? (
                        <Grid xs={3.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button size="md" variant='solid' onClick={currentTab == 0 ? () => setOpen(true) : navigateToPage} color="primary" startDecorator={<img className='imgIconButton' src={AddIcon} alt='icon' />}>
                                {currentTabActive == 0 ? " إضافة ماركة جديدة" : "إضافة موديل جديد"}
                            </Button>
                        </Grid>
                    ) : null}

                    {(adminType == 1 && roleId.includes(3)) ? (
                        <Grid xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button size="md" variant='solid' onClick={navigateToPageAccess} color="primary" startDecorator={<img className='imgIconButton' src={AddIcon} alt='icon' />}>
                                {"إضافة موديل جديد"}
                            </Button>
                        </Grid>
                    ) : null}
                </Grid>

                {(adminType == 0) ? (
                    <>
                        <TabPanel value={0} sx={{ backgroundColor: '#FFF' }}>
                            <TableCarBrand listBrands={listBrands} listAllBrands={listAllBrands} />
                            {loadingData ? (
                                <LinearProgress />
                            ) : null}
                        </TabPanel>
                        <TabPanel value={1} sx={{ backgroundColor: '#FFF' }}>
                            <TableCarModal />
                        </TabPanel>
                        <TabPanel value={2} sx={{ backgroundColor: '#FFF' }}>
                            <UploadFileModels />
                        </TabPanel>
                    </>
                ) : (
                    <>
                        <TabPanel value={0} sx={{ backgroundColor: '#FFF' }}>
                            <TableCarModal />
                        </TabPanel>

                        <TabPanel value={1} sx={{ backgroundColor: '#FFF' }}>
                            <UploadFileModels />
                        </TabPanel>
                    </>

                )}

            </Tabs>
        </>
    )
}